import DateTimeUtil from "utils/DateTimeUtil.js";
import {DATE_FORMATS} from "constants/AppConstants.js";

/** The title the app shows for the activity, followed by its date: "Wingfoil, Afternoon 2026-10-25". */
export function getGpxTitle(activity: any): string {
  const title = activity.name || activity.secondaryName || activity.waterSportName || "Waterspeed activity";
  const date = DateTimeUtil.convertDateToString(new Date(activity.originalDate.getTime()), DATE_FORMATS.YYYY_MM_DD);
  return `${title} ${date}`;
}

export function getGpxFileName(activity: any): string {
  return `${getGpxTitle(activity).replace(/[\\/:*?"<>|]+/g, "-")}.gpx`;
}
